import React from "react";

import {
  FaTruck,
  FaRoad,
  FaShieldAlt,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaFileInvoiceDollar,
  FaChartBar,
  FaCheckCircle,
  FaDatabase,
  FaReact,
  FaNodeJs,
  FaCode,
} from "react-icons/fa";

import Footer from "../components/Footer";

import "../css/acercade.css";

const modulos = [
  {
    icon: FaTruck,
    titulo: "Viajes y logística",
    texto:
      "Gestión integral de viajes, comandas, choferes, camiones, destinos y documentación.",
    clase: "azul",
  },

  {
    icon: FaMoneyBillWave,
    titulo: "Cajas y finanzas",
    texto:
      "Control de cajas, cuentas bancarias, ingresos, egresos, pagos y movimientos financieros.",
    clase: "violeta",
  },

  {
    icon: FaFileInvoiceDollar,
    titulo: "Rendiciones",
    texto:
      "Liquidación de viajes, gastos, adelantos, combustible y obligaciones asociadas.",
    clase: "rojo",
  },

  {
    icon: FaExchangeAlt,
    titulo: "Tesorería y cartera",
    texto:
      "Administración de cheques, eCheq, cuentas corrientes, órdenes de pago y cobranzas.",
    clase: "verde",
  },

  {
    icon: FaRoad,
    titulo: "Peajes",
    texto:
      "Importación de consumos, conciliación, facturación, pagos e informes de telepeaje.",
    clase: "celeste",
  },

  {
    icon: FaShieldAlt,
    titulo: "Seguros",
    texto:
      "Pólizas, vehículos asegurados, vencimientos, facturación, pagos e informes.",
    clase: "esmeralda",
  },

  {
    icon: FaChartBar,
    titulo: "Informes y control",
    texto:
      "Reportes operativos, financieros, dashboards, auditoría y exportación a Excel y PDF.",
    clase: "naranja",
  },
];

const mejoras = [
  "Nuevo Home general con accesos rápidos por módulo.",
  "Navbar renovado y navegación unificada.",
  "Módulo completo de Peajes con conciliación y pagos.",
  "Módulo de Seguros con pólizas, vehículos, vencimientos y pagos.",
  "Informes reorganizados por área funcional.",
  "Gestión de Altas modernizada.",
  "Auditoría y dashboards de control.",
  "Exportaciones Excel y PDF en los principales informes.",
];

const AcercaDe = () => {
  return (
    <>
      <main className="about-page">
        {/* =================================================
            HERO
        ================================================= */}

        <section className="about-hero">
          <div className="about-version">
            DANLU · VERSIÓN 2.0
          </div>

          <h1>
            Sistema Integral de Gestión
          </h1>

          <h2>
            Transporte DANLU
          </h2>

          <p>
            Plataforma desarrollada para centralizar
            la operación logística, administrativa y
            financiera de Transporte DANLU en un único
            sistema.
          </p>

          <div className="about-status">
            <FaCheckCircle />

            <span>
              Sistema operativo y en evolución continua
            </span>
          </div>
        </section>

        {/* =================================================
            INFORMACIÓN GENERAL
        ================================================= */}

        <section className="about-intro">
          <div>
            <span className="about-eyebrow">
              SOBRE EL SISTEMA
            </span>

            <h2>
              Mucho más que seguimiento de viajes
            </h2>

            <p>
              DANLU nació para organizar la gestión de
              viajes y fue evolucionando hasta convertirse
              en una plataforma integral que conecta
              operación, administración, tesorería,
              documentación y control.
            </p>

            <p>
              La información se encuentra relacionada entre
              los distintos módulos, permitiendo mantener
              trazabilidad desde la operación del transporte
              hasta sus movimientos financieros.
            </p>
          </div>

          <div className="about-numbers">
            <div>
              <strong>
                2.0
              </strong>

              <span>
                Versión actual
              </span>
            </div>

            <div>
              <strong>
                7+
              </strong>

              <span>
                Áreas integradas
              </span>
            </div>

            <div>
              <strong>
                100%
              </strong>

              <span>
                Gestión web
              </span>
            </div>
          </div>
        </section>

        {/* =================================================
            MÓDULOS
        ================================================= */}

        <section className="about-section">
          <div className="about-section-title">
            <span>
              PLATAFORMA
            </span>

            <h2>
              Principales áreas de gestión
            </h2>

            <p>
              Los módulos trabajan de manera integrada
              dentro de la misma plataforma.
            </p>
          </div>

          <div className="about-module-grid">
            {modulos.map(
              ({
                icon: Icon,
                titulo,
                texto,
                clase,
              }) => (
                <div
                  className={`about-module-card ${clase}`}
                  key={titulo}
                >
                  <div className="about-module-icon">
                    <Icon />
                  </div>

                  <div>
                    <h3>
                      {titulo}
                    </h3>

                    <p>
                      {texto}
                    </p>
                  </div>
                </div>
              )
            )}
          </div>
        </section>

        {/* =================================================
            VERSIÓN 2.0
        ================================================= */}

        <section className="about-version-section">
          <div className="about-version-header">
            <div>
              <span className="about-eyebrow">
                EVOLUCIÓN
              </span>

              <h2>
                DANLU 2.0
              </h2>

              <p>
                La versión actual incorpora una renovación
                funcional y visual de la plataforma.
              </p>
            </div>

            <div className="about-version-badge">
              2.0
            </div>
          </div>

          <div className="about-improvements">
            {mejoras.map(
              (item) => (
                <div
                  className="about-improvement"
                  key={item}
                >
                  <FaCheckCircle />

                  <span>
                    {item}
                  </span>
                </div>
              )
            )}
          </div>
        </section>

        {/* =================================================
            TECNOLOGÍA
        ================================================= */}

        <section className="about-tech">
          <div className="about-section-title">
            <span>
              TECNOLOGÍA
            </span>

            <h2>
              Arquitectura del sistema
            </h2>
          </div>

          <div className="about-tech-grid">
            <div className="about-tech-item">
              <FaReact />

              <div>
                <strong>
                  React
                </strong>

                <span>
                  Interfaz web
                </span>
              </div>
            </div>

            <div className="about-tech-item">
              <FaNodeJs />

              <div>
                <strong>
                  Node.js
                </strong>

                <span>
                  Backend y API
                </span>
              </div>
            </div>

            <div className="about-tech-item">
              <FaDatabase />

              <div>
                <strong>
                  MongoDB
                </strong>

                <span>
                  Base de datos
                </span>
              </div>
            </div>

            <div className="about-tech-item">
              <FaCode />

              <div>
                <strong>
                  Desarrollo propio
                </strong>

                <span>
                  Adaptado a DANLU
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* =================================================
            FIRMA
        ================================================= */}

        <section className="about-signature">
          <p>
            Sistema desarrollado y mantenido para
            Transporte DANLU.
          </p>

          <strong>
            © {new Date().getFullYear()} Transporte DANLU
          </strong>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default AcercaDe;